import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import guestlectureService from "./guestlectureService";

export const getGuestLectures = createAsyncThunk(
  "guestlectures/get-guestlectures",
  async (thunkAPI) => {
    try {
      return await guestlectureService.getGuestLectures();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getGuestLecturesmanu = createAsyncThunk(
  "guestlectures/get-guestlecturesmanu",
  async (thunkAPI) => {
    try {
      return await guestlectureService.getGuestLecturesmanu();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAGuestLectures = createAsyncThunk(
  "guestlecture/delete-guestlecture",
  async (id, thunkAPI) => {
    try {
      return await guestlectureService.deleteGuestLectures(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getAGuestLectures = createAsyncThunk(
  "guestlecture/get-guestlecture",
  async (id, thunkAPI) => {
    try {
      return await guestlectureService.getGuestLectures(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAGuestLectures = createAsyncThunk(
  "guestlecture/update-guestlecture",
  async (enq, thunkAPI) => {
    try {
      return await guestlectureService.udpateGuestLectures(enq);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  guestlecture: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const guestlecturesSlice = createSlice({
  name: "guestlectures",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGuestLectures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGuestLectures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.guestlecture = action.payload;
      })
      .addCase(getGuestLectures.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getGuestLecturesmanu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGuestLecturesmanu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.guestlecture = action.payload.data;
      })
      .addCase(getGuestLecturesmanu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAGuestLectures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAGuestLectures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedGuestLectures = action.payload;
      })
      .addCase(deleteAGuestLectures.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAGuestLectures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAGuestLectures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enqName = action.payload.name;
        state.enqMobile = action.payload.mobile;
        state.enqEmail = action.payload.email;
        state.enqComment = action.payload.comment;
        state.enqStatus = action.payload.status;
      })
      .addCase(getAGuestLectures.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAGuestLectures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAGuestLectures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedGuestLectures = action.payload;
      })
      .addCase(updateAGuestLectures.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default guestlecturesSlice.reducer;
